import { Injector } from '@angular/core';
import { GA1Service } from './shared/ga1/ga1.service';
import { BodyClassService } from './shared/services/body-class.service';
import { TitleService } from './shared/services/title.service';
import { GA1FieldLabelService } from './shared/ga1-field-label/ga1-field-label.service';
import { ALLOWED_LANGUAGES, DEFAULT_LANGUAGE } from './shared/language/language-data.service';
import { TranslateService } from '@ngx-translate/core';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AG_GRID_LICENSE_KEY } from '../environments/ag-grid-license';
import { MailInvoiceService } from './shared/mail-invoice/mail-invoice.service';

export function appInitializer(injector:Injector) {
  return () => {
    const ga1Service:GA1Service = injector.get(GA1Service);
    const bodyClassService:BodyClassService = injector.get(BodyClassService);
    const titleService:TitleService = injector.get(TitleService);
    const translateService:TranslateService = injector.get(TranslateService);
    const ga1FieldLabelService:GA1FieldLabelService = injector.get(GA1FieldLabelService);
    const mailInvoiceService:MailInvoiceService = injector.get(MailInvoiceService);

    // activate ga1 field label service
    ga1FieldLabelService.activate();
    mailInvoiceService.listen();

    // set body class initializer
    if (ga1Service.embedded()) {
      bodyClassService.add('inframe');
    } else {
      bodyClassService.add('fixed-header');
    }

    // set page title initializer
    titleService.setPrefix();

    // set initial translations
    translateService.addLangs(ALLOWED_LANGUAGES);
    translateService.setDefaultLang(DEFAULT_LANGUAGE);

    // ag-grid license
    LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

    // internal method for stubbing in cypress
    (<any>window).cyWindowStub = ():void => {/**/};
  };
}